import React, { useEffect, useState } from 'react';
import { CircularProgress, FormControl, FormHelperText, Grid, InputLabel, Select, TextField } from '@material-ui/core';

import { Field } from 'formik';
import helpers from 'app/utils/helpers';
import { KeyboardDatePicker } from '@material-ui/pickers';
import InputMask from 'react-input-mask';
import { useDispatch, useSelector } from 'react-redux';
import { fetchCities } from 'app/store/slices/forms';
import { STATE_CITY } from 'app/utils/constants';
import userEndpoints from 'app/api/services/userEndpoints';

const SurveyInfo = (props) => {
    const timeMask = '99:99';
    const dispatch = useDispatch();

    const { classes, canEdit, errors, values, onChangeDate, loadingSituation, situation } = props;

    const cities = useSelector((state) => state.forms.cities);

    const [loading, setLoading] = useState(false);
    const [users, setUsers] = useState([]);
    const [loadingUser, setLoadingUser] = useState(false);

    useEffect(() => {
        const init = async () => {
            setLoading(true);
            const promisses = [];
            if (cities.length === 0) promisses.push(dispatch(fetchCities(STATE_CITY)));
            if (promisses.length > 0) await Promise.all(promisses);
            setLoading(false);
        };
        init();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dispatch]);

    useEffect(() => {
        const init = async () => {
            setLoadingUser(true);
            try {
                if (canEdit) {
                    const response = await userEndpoints.findUsers();
                    if (response.status === 200 && response.data) {
                        setUsers(response.data);
                    }
                } else {
                    if (values.cdVistoriador) {
                        const response = await userEndpoints.getUserInformations(values.cdVistoriador);
                        if (response.status === 200 && response.data) {
                            setUsers([response.data]);
                        }
                    }
                }
            } catch (error) {}
            setLoadingUser(false);
        };
        init();
    }, [canEdit, values.cdVistoriador]);

    return (
        <>
            <Grid item xs={12}>
                <h2 className={classes.title}>Informações da vistoria</h2>
            </Grid>
            <Grid item xs={12} sm={3} className={classes.positionRelative}>
                {loading && (
                    <div className={classes.loadingUser}>
                        <CircularProgress size={20} />
                    </div>
                )}
                <FormControl variant="filled" margin="dense" fullWidth error={!!errors.cdMunicipioVistoria}>
                    <InputLabel shrink={true} htmlFor="cdMunicipioVistoria">
                        Município da vistoria*
                    </InputLabel>
                    <Field name="cdMunicipioVistoria" id="cdMunicipioVistoria" disabled={!canEdit} native as={Select}>
                        <option aria-label="None" value="">
                            Selecione
                        </option>
                        {cities.map((c, index) => {
                            return (
                                <option key={`type-${index}`} value={c.cdMunicipio}>
                                    {c.nmMunicipio}
                                </option>
                            );
                        })}
                    </Field>
                    {errors.cdMunicipioVistoria ? <FormHelperText>{errors.cdMunicipioVistoria}</FormHelperText> : null}
                </FormControl>
            </Grid>
            <Grid item xs={12} sm={3} className={classes.positionRelative}>
                {loadingUser && (
                    <div className={classes.loadingUser}>
                        <CircularProgress size={20} />
                    </div>
                )}
                <FormControl variant="filled" margin="dense" fullWidth error={!!errors.cdVistoriador}>
                    <InputLabel htmlFor="cdVistoriador" shrink={true}>
                        Vistoriador*
                    </InputLabel>
                    <Field name="cdVistoriador" id="cdVistoriador" native disabled={!canEdit} as={Select}>
                        <option value=""></option>
                        {users.map((u, index) => {
                            return (
                                <option key={`type-${index}`} value={u.cdUsuario}>
                                    {u.nmUsuario}
                                </option>
                            );
                        })}
                    </Field>
                    {errors.cdVistoriador ? <FormHelperText>{errors.cdVistoriador}</FormHelperText> : null}
                </FormControl>
            </Grid>
            <Grid item xs={12} sm={3}>
                <Field
                    name="dtVistoria"
                    label="Data da vistoria*"
                    format="DD/MM/YYYY"
                    autoOk
                    clearable
                    clearLabel={'Limpar'}
                    emptyLabel={''}
                    value={helpers.formatarData(values.dtVistoria)}
                    invalidLabel="Data inválida"
                    invalidDateMessage="Data inválida"
                    maxDateMessage="Data inválida"
                    minDateMessage="Data inválida"
                    margin="dense"
                    disabled={!canEdit}
                    onChange={(v) => onChangeDate('dtVistoria', v.startOf('day'), props.setFieldValue)}
                    KeyboardButtonProps={{
                        'aria-label': 'change date',
                    }}
                    inputVariant="filled"
                    fullWidth
                    InputLabelProps={{
                        shrink: true,
                    }}
                    error={!!errors.dtVistoria}
                    helperText={errors.dtVistoria ? errors.dtVistoria : ''}
                    as={KeyboardDatePicker}
                />
            </Grid>

            <Grid item xs={12} sm={3}>
                {canEdit && (
                    <Field name="hrVistoria">
                        {({ field, form: { errors, values } }) => (
                            <InputMask mask={timeMask} {...field} value={values.hrVistoria}>
                                {(props) => (
                                    <TextField
                                        {...props}
                                        name="hrVistoria"
                                        label="Horário*"
                                        variant="filled"
                                        margin="dense"
                                        fullWidth
                                        error={!!errors.hrVistoria}
                                        helperText={errors.hrVistoria ? errors.hrVistoria : ''}
                                    />
                                )}
                            </InputMask>
                        )}
                    </Field>
                )}
                {!canEdit && (
                    <TextField
                        variant="filled"
                        margin="dense"
                        label="Horário*"
                        disabled={!canEdit}
                        fullWidth
                        value={values.hrVistoria}
                        name="hrVistoria"
                        InputLabelProps={{
                            shrink: true,
                        }}
                    />
                )}
            </Grid>

            <Grid item xs={12}>
                <Field
                    name="deObservacao"
                    label="Observações"
                    variant="filled"
                    margin="dense"
                    disabled={!canEdit}
                    multiline
                    minRows={4}
                    fullWidth
                    as={TextField}
                    inputProps={{
                        maxLength: 4000,
                    }}
                />
            </Grid>
            <Grid item xs={12} sm={4}>
                {loadingSituation && <CircularProgress size={18} />}
                {!loadingSituation && (
                    <Field
                        name="tpSituacao"
                        label="Situação do veículo"
                        variant="filled"
                        margin="dense"
                        disabled={true}
                        value={situation}
                        fullWidth
                        error={!!errors.tpSituacao}
                        helperText={errors.tpSituacao ? errors.tpSituacao : ''}
                        as={TextField}
                        inputProps={{
                            maxLength: 10,
                        }}
                    />
                )}
            </Grid>
        </>
    );
};

export default SurveyInfo;
